import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';

const Header = dynamic(() => import('@components/organisms/Header/Header').then((module) => module.Header));
const Footer = dynamic(() => import('@components/organisms/Footer/Footer').then((module) => module.Footer));

export const Service = ({ children }: PropsWithChildren) => {
  return (
    <div className="grid min-h-screen grid-rows-[1fr_auto] bg-gray-200">
      <Header classProps={{ root: '' }} filled={true} />
      <main className="w-full min-w-0 text-clip lg:mt-24">{children}</main>
      <Footer />
    </div>
  );
};
